import EventBus from "../../plugins/event-bus";
import Request from 'plugin-tigre-request';
import utils from '@/utils';
import { getUserId, getUserCountry, getCustomerId, getToken } from '../userData';

const defaultRequestParam = (path) => {
  return {
    ...utils.makeDefaultRequestData(),
    resource: path,
  };
};

const state = {
  credito: {},
  creditoDate: "",
};

const getters = {};

const mutations = {
  cleanState(state) {
    state.credito = {};
    state.creditoDate = "";
  },
  setCredito(state, payload) {
    const { row } = payload;

    state.credito = row.limite;
    state.credito.consumido = state.credito.limiteTotal - state.credito.limiteDisponivel;
    state.credito.percentualConsumido = 0;
    state.credito.excedidoPercentual = 0;
    state.credito.isTigre = row.isTigre;

    if (state.credito.consumido && state.credito.limiteTotal) {
      state.credito.percentualConsumido = Math.floor((state.credito.consumido / state.credito.limiteTotal) * 100);
    }

    if (state.credito.limiteExcedido) {
      state.credito.excedidoPercentual = Math.floor((state.credito.limiteExcedido/state.credito.limiteTotal) * 100 )
    }

    let percentualTotal = 100.0 + state.credito.excedidoPercentual;

    state.credito.percentual = Math.floor(
      100.0 * (state.credito.percentualConsumido / percentualTotal)
    );

    state.creditoDate = row.dataConsulta + ' ' + row.horaConsulta;
    EventBus.loading(false);
  },
};

const actions = {
  async getById({commit}) {
    EventBus.loading(true);
    const USERID = getUserId();
    let requestParam = {
      ...defaultRequestParam('venusa/credito'),
      data: { USERID, ...getUserCountry(), FIN: getCustomerId(), TOKEN: getToken() },
      method: 'GET',
    };
    let response;
    try {
      response = await Request(requestParam);
      commit('setCredito', { row: response.data.dados });
      EventBus.loading(false);
    } catch (error) {
      response = error;
    }
  },
  async getByFin({ commit }) {
    EventBus.loading(true);
    const USERID = getUserId();
    let requestParam = {
      ...defaultRequestParam("venusa/credito"),
      data: { USERID, ...getUserCountry(), FIN: getCustomerId(), TOKEN: getToken() },
      method: "GET"
    };
    let response;
    try {
      response = await Request(requestParam);
      commit("setCredito", { row: response.data.dados });
      EventBus.loading(false);
    } catch (error) {
      response = error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
